import React from 'react';
import moment from 'moment-timezone';
import i18n from '../i18n';
import { BusinessMenu } from '../constants/type.constant';
import { getCacheField } from '../tools/get-cache-field';
import { getSettingInfo } from '../tools/get-setting-info';
import _ from 'lodash';
import { DefaultRequest } from '../requests/default.request';
import Store from '../redux/store';
import { MessengerModule } from '../messenger/module';
import { withSnackbar, WithSnackbarProps } from 'notistack';
import { Button } from '@material-ui/core';
import { WebsocketClient } from '../websocket/module';
import { getCurrentBusinessMenu, isNewBusiness, scheduleTransform } from '../constants/tools.constant';
import ServerShoppingCart from '../modules/server-shopping-cart';
import { getSeverAndLoacalDiff, setLocalDateByDiff } from '../tools/local-moment';

class DisableDish extends React.PureComponent<Props, State> {
    public messengerModule: MessengerModule;
    // $ 时间提示提前展示
    public timerAdvance: NodeJS.Timeout | any = 0;
    public state: State = {
        // 点餐时间段参数
        dishMoment: getCacheField('currentMenu'),
        currentMoment: moment(setLocalDateByDiff(Store.getState().diffTimeStamp)).format('HH:mm'),
        isDishMoment: false,
        timeNotice: 15,
        isAdvanceMoment: true,
        isMomentTime: false
    };

    constructor(props: Props) {
        super(props);
        this.messengerModule = new MessengerModule(this.props.enqueueSnackbar);
    }
    async UNSAFE_componentWillMount() {
        // 获取服务器与本地时间戳差值
        const diffTimeStamp = await getSeverAndLoacalDiff();
        Store.dispatch({
            type: 'SET_CACHING',
            path: 'diffTimeStamp',
            value: diffTimeStamp,
        })
        this.getCurrentBusinessMenu()
    }
    public componentDidMount() {
    }

    public componentWillUnmount() {
        clearTimeout(this.timerAdvance);
    }

    /**
     * 获取营业时间资源
     */
    public async getCurrentBusinessMenu() {
        try {
            let BUSINESS_RES: BusinessMenu[] = [];
            // 新营业时间
            if (isNewBusiness()) {
                const result = await DefaultRequest.getBusinessHour2Project();
                const SCHEDULE = scheduleTransform(_.get(result, '[0].value', []));
                BUSINESS_RES = getCurrentBusinessMenu(SCHEDULE)
            }
            // 旧营业时间
            else {
                BUSINESS_RES = await DefaultRequest.getCurrentBusinessMenu()
            }
            // 营业时间存在
            if (_.get(BUSINESS_RES, '0')) {
                // 是否处于点餐时间
                Store.dispatch({
                    type: 'SET',
                    path: 'isBusinessTime',
                    value: false
                })
                // 当前营业时间段
                Store.dispatch({
                    type: 'SET_CACHING',
                    path: 'currentMenu',
                    value: BUSINESS_RES
                })
                this.setState({
                    dishMoment: _.get(BUSINESS_RES, '0')
                }, () => {
                    // 倒计时
                    this.advanceDishMoment();
                })
            }
            // 营业时间不存在
            else {
                // 由于厨房已关闭 部分菜单已禁用
                this.messengerModule.say({
                    message: `${i18n.t('menu_page_text_dish_time_disable')}`,
                    level: 'Warning'
                })
                // 是否处于点餐时间
                Store.dispatch({
                    type: 'SET',
                    path: 'isBusinessTime',
                    value: true
                })
            }
        } catch (error) {

        }
    }
    public async initializeTurnData(time: number) {
        this.timerAdvance = setTimeout(
            () => {
                this.advanceDishMoment();
            },
            time
        );
    }

    public forbidDishAndClear() {
        clearTimeout(this.timerAdvance);
    }

    /**
     * 营业点餐时间段处理
     */
    public advanceDishMoment() {
        // 获取设置：结束营业前通知时间
        let appearTime = getSettingInfo('disable-order-notice-appear-time', 'value')
        const { dishMoment } = this.state
        // 如果没有设置，默认15
        const ADVANCETIME = appearTime ? appearTime.mins : 15;
        // 当前时间
        let currentMoment = moment(moment(setLocalDateByDiff(Store.getState().diffTimeStamp)).format('HH:mm'), 'hh:mm')
        // 开始时间存在
        if (_.get(dishMoment, 'start_time')) {
            // $ 开始时间  isBetween方法用于区别两值的区间 会造成延迟1分钟 所以提前一分钟
            let beforeTime = moment(dishMoment.start_time, 'hh:mm').subtract(1, 'minutes');
            beforeTime.set({'year': currentMoment.year(), 'month' : currentMoment.month(), 'date': currentMoment.date()})
            // $ 结束时间
            let afterTime = moment(dishMoment.end_time, 'hh:mm');
            afterTime.set({'year': currentMoment.year(), 'month' : currentMoment.month(), 'date': currentMoment.date()})
            // $ 提前通知时间 isBetween方法用于区别两值的区间 会造成延迟1分钟 所以ADVANCETIME要加1
            let advanceTime = moment(dishMoment.end_time, 'hh:mm').subtract(ADVANCETIME * 1 + 1, 'minutes');
            advanceTime.set({'year': currentMoment.year(), 'month' : currentMoment.month(), 'date': currentMoment.date()})
            if (dishMoment.end_time === '24:00') {
                afterTime.add(1, 'day')
                advanceTime.add(1, 'day')
            }
            // 时间差值
            let timeDiff = 0;
            timeDiff = afterTime.diff(currentMoment, 'minute');

            //  识别差值大于0后,再判断它是否处于 ‘处于营业时间段’ 内
            if (timeDiff <= ADVANCETIME) this.setState({ timeNotice: timeDiff });
            // $ 不在提前时间 && 处于营业时间
            const transCurrentMoment = moment(currentMoment, 'hh:mm');
            transCurrentMoment.set({'year': currentMoment.year(), 'month' : currentMoment.month(), 'date': currentMoment.date()})
            if (
                !transCurrentMoment.isBetween(advanceTime, afterTime) &&
                transCurrentMoment.isBetween(beforeTime, afterTime)
            ) {
                // 在到达提前通知时间时触发通知
                const alertTime = 60 * (timeDiff - ADVANCETIME) * 1000;
                this.initializeTurnData(alertTime);
            } else {
                // $ 提前通知时间段
                if (transCurrentMoment.isBetween(advanceTime, afterTime)) {
                    setTimeout(
                        () => {
                            this.advanceDishMoment();
                        },
                        1000
                    );
                    Store.getState().businessTimeStatus && this.setState({ isMomentTime: true })

                    // 在到达营业结束时间时触发通知
                    this.timerAdvance = setTimeout(
                        () => {
                            Store.dispatch({
                                type: 'SET',
                                path: 'isBusinessTime',
                                value: true
                            })
                            this.setState({
                                isMomentTime: false
                            })
                            // // $ 进入下一轮时,清空上一轮次的购物车菜品
                            // getCacheField('personArr').forEach((customer: string) => {
                            //     ShoppingCart.clearCart(ShoppingCart.globalRound, customer);
                            // })
                            // // 缓存购物车
                            // Store.dispatch({
                            //     type: 'SET_CACHING',
                            //     path: 'shoppingCart',
                            //     value: ShoppingCart.metaData
                            // })
                            ServerShoppingCart.emptyCartItem({ all: true })
                            WebsocketClient.emit('CLEAT_DISH_VIEW')
                        },
                        60 * timeDiff * 1000
                    );
                }

            }
        }
        // 开始时间不存在
        else {
            this.forbidDishAndClear()
        }
    }

    public render() {
        const { isMomentTime } = this.state;
        return (
            <div className={isMomentTime ? 'momentModal' : 'momentModal momentModal_top_close'} >
                <div>
                    <div className='noticeTimeText'>{i18n.t('menu_page_text_notice_time', { time: this.state.timeNotice })}</div>
                    <div className='closeBtn'>
                        <Button
                            className='closeBtn-button'
                            onClick={() => {
                                this.setState({ isMomentTime: false })
                                Store.dispatch({
                                    type: 'SET',
                                    path: 'businessTimeStatus',
                                    value: false
                                })
                            }}>{i18n.t('general_button_close')}</Button>
                    </div>
                </div>
            </div>
        );
    }
}
export default withSnackbar(DisableDish)

// *********************
// Types
// *********************
type Props = {
} & WithSnackbarProps;

type State = {
    // 禁止点餐时间段
    dishMoment: BusinessMenu;
    // 当前时间
    currentMoment: any;
    // 是否禁用
    isDishMoment: boolean;
    timeNotice: number;
    // 禁用时间是否提前通知
    isAdvanceMoment: boolean;
    // 是否显示营业时间提示
    isMomentTime: boolean;
};
